import * as types from "../constants/actionTypes";

export const profileToolsInitialState = {
    fluConsent: null,
    fluPending: false,
    fluSuccess: false,
    consentPending: false,
    consentGetSuccess: false,
    consentSetSuccess: false,
    consentList: [],
    consentType: null,
    consentTypeList: null,
    consentTypePending: false,
    consentTypeSuccess: false,
    consentTypeFailure: false
};

export default function profileToolsReducer(state = profileToolsInitialState, action) {
    switch (action.type) {
        case types.CONSENT_GET_PENDING:
            return { ...state, consentPending: true };
        case types.CONSENT_FLU_PENDING:
            return { ...state, fluPending: true };
        case types.CONSENT_FLU_SUCCESS:
            return { ...state, fluConsent: action.consent, fluSuccess: true, fluPending: false };
        case types.CONSENT_FLU_FAILURE:
            return { ...state, fluConsent: null, fluSuccess: false, fluPending: false };
        case types.CONSENT_GET_SUCCESS:
            return { ...state, fluConsent: action.consent, consentPending: false, consentGetSuccess: true };
        case types.CONSENT_GET_FAILURE:
            return { ...state, fluConsent: null, consentPending: false, consentGetSuccess: false };
        case types.CONSENT_SET_SUCCESS:
            return { ...state, fluConsent: action.consent, consentPending: false, consentSetSuccess: true };
        case types.CONSENT_SET_FAILURE:
            return { ...state, consentPending: false, consentSetSuccess: false };
        case types.CONSENT_GET_LIST_SUCCESS:
            return { ...state, consentList: action.consent.results && action.consent.results.length > 0 ? action.consent.results : [], consentPending: false, consentGetSuccess: true };
        case types.CONSENT_GET_LIST_FAILURE:
            return { ...state, consentList: [], consentPending: false, consentGetSuccess: false };
        case types.CONSENT_TYPE_PENDING:
        case types.CONSENT_TYPE_LIST_PENDING:
            return { ...state, consentTypePending: true, consentTypeFailure: false };
        case types.CONSENT_TYPE_SUCCESS:
            return { ...state, consentType: action.consent, consentTypePending: false, consentTypeSuccess: true };
        case types.CONSENT_TYPE_FAILURE:
            return { ...state, consentType: null, consentTypePending: false, consentTypeSuccess: true };
        case types.CONSENT_TYPE_LIST_SUCCESS:
            return { ...state, consentTypeList: action.consent ? action.consent.results : [], consentTypePending: false, consentTypeSuccess: true, consentTypeFailure: false };
        case types.CONSENT_TYPE_LIST_FAILURE:
            return { ...state, consentTypeList: [], consentTypePending: false, consentTypeSuccess: false, consentTypeFailure: true };
        case types.LOGOUT:
            return profileToolsInitialState;
        default:
            return { ...state };
    }
}
